
















































































































































































































































import Vue from "vue";
import AppTableRow from "@/components/table/AppTableRow.vue";
import SensitivityLabel from "@/components/SensitivityLabel.vue";
import { EventBus } from "@/eventbus";
import { CopyUrl } from "@/common/clipboard";
import { computed, ref } from "@vue/composition-api";
import { UseModal } from "@/components/root/modal";
import FileDetailsModalVue from "@/components/modals/FileDetailsModal.vue";
import EmptyCell from "@/components/EmptyCell.vue";
import SpiMarker from "@/components/SpiMarker.vue";
export default Vue.extend({
  props: ["source"],
  components: {
    AppTableRow,
    SensitivityLabel,
    EmptyCell,
    SpiMarker,
  },
  setup(props) {
    const showLoader = ref(false);

    const showMenu = (event: MouseEvent) =>
      EventBus.emit("showFileMenu", { item: props.source, event });

    const context_labels_tooltip_data = computed(() => {
      // @ts-ignore
      const { context } = props.source;
      return ["Context Labels", ...context.map((d: any) => d.name)];
    });

    const toolipData = computed(() => {
      // @ts-ignore
      const { exposedPersonCount, someExposedToRefs } = props.source.details;
      if (!someExposedToRefs || !someExposedToRefs.length) return [];
      const res = [
        "Exposed To",
        ...someExposedToRefs.map((d: any) => d.emailAddress),
      ];
      const diff = exposedPersonCount - someExposedToRefs.length;
      if (diff > 0) {
        res.push(`and ${diff} more...`);
      }
      return res;
    });

    const showDetailsPopup = () => {
      // @ts-ignore
      UseModal().show(FileDetailsModalVue, { ...props.source });
    };

    const showConfidencePopup = (event: MouseEvent) => {
      EventBus.emit("confidence-popup", {
        source: props.source,
        event,
      });
    };

    const showHistory = () => {
      EventBus.emit("showHistory", props.source);
    };

    const archiveTooltip = (
      archive: { archiveName?: string },
      archiveItems: string[] = []
    ) => {
      if (archiveItems.length > 0) {
        return ["Contains:", ...archiveItems];
      }
      return [archive?.archiveName ? `part of: ${archive.archiveName}` : "Archive"];
    };

    return {
      CopyUrl,
      showMenu,
      toolipData,
      context_labels_tooltip_data,
      showDetailsPopup,
      showLoader,
      showConfidencePopup,
      showHistory,
      archiveTooltip,
    };
  },
});
